
import { FileOutlined, FolderOpenFilled } from "@ant-design/icons";
import React from "react";
import FolderIcon from "@src/styles/icon/folder-icon.svg";

// GET PARENT KEY
export function findParent(data, targetKey, path = []) {
    for (const item of data) {
      const currentPath = [...path, item];
      if (item.key === targetKey) {
        return path;
      }
      if (item.children) {
        const result = findParent(item.children, targetKey, currentPath);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  export const transformData = (data, parentKey = "", expandedKeys = [],fontSize) => {
    return data.map((item, index) => {
      const eachKey =
        item.itemCode !== "" &&
        item.itemCode !== null &&
        item.itemCode !== undefined
          ? item.itemCode  + "-" + item.id
          : item.typeKey;
      const key = parentKey !== "" ? `${parentKey}-${eachKey}` : `${eachKey}`;
      // const key = item.id || item.typeKey
      // const type = !item.type ? ORDER_TREE.EQUIPMENT : Number(item.type);
  
      const isOpen = expandedKeys.includes(key);
      const hasChildren =
        Array.isArray(item.children) && item.children.length > 0;
      const order = item.type ? Number(item.type) : 0;
      const name = item.typeName || item.itemName;
      return {
        title: (
          <span
            style={{
              marginLeft: 5,
              fontSize
            }}
          >
            {name}
          </span>
        ),
        name: name,
        key: key,
        code: item.itemCode || item.typeKey,
        id: item.id || item.typeKey,
        order,
        typeName: item.typeName || "",
        machineClassification: item.typeKey || "",
        position: item.displayOrder,
        icon: hasChildren ? (
          !isOpen ? (
            <img
              style={{ width: 20, height: 20 }}
              src={FolderIcon}
              alt=""
              className="icon__confirm"
            />
          ) : (
            <FolderOpenFilled style={{ color: "#0080cb", fontSize: 23 }} />
          )
        ) : (
          <FileOutlined style={{ fontSize: 16 }} />
        ),
        isLeaf: !hasChildren,
        children: hasChildren
          ? transformData(item.children, key, expandedKeys)
          : order != 4
          ? []
          : undefined,
      };
    });
  };
//  export const transformData = (data, parentKey = "", expandedKeys = []) => {
//     return data.map((item) => {
//       const key = parentKey ? `${parentKey}-${item.code}` : item.code;
//       const isOpen = expandedKeys.includes(key);
//       const hasChildren = Array.isArray(item.children) && item.children.length > 0;
//       return {
//         title: <span style={{ marginLeft: 5 }}>{item.title}</span>,
//         name: item.title,
//         key,
//         code: item.code,
//         order: key.split("-").length,
//         icon: hasChildren
//           ? !isOpen
//             ? <img style={{ width: 20, height: 20 }} src={FolderIcon} alt="" />
//             : <FolderOpenFilled style={{ color: "#0080cb", fontSize: 23 }} />
//           : <FileOutlined style={{ fontSize: 16 }} />,
//         isLeaf: !hasChildren,
//         children: hasChildren ? transformData(item.children, key, expandedKeys) : undefined,
//       };
//     });
//   };